import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CustomFieldConfig } from '@features/member-management/types';

interface BranchConfigState {
  memberCustomFields: CustomFieldConfig[];
}

const initialState: BranchConfigState = {
  memberCustomFields: []
};

export const branchConfigSlice = createSlice({
  name: 'branchConfig',
  initialState,
  reducers: {
    setMemberCustomFields: (
      state,
      action: PayloadAction<CustomFieldConfig[]>
    ) => {
      state.memberCustomFields = action.payload;
    },
    resetBranchConfig: () => initialState
  }
});

export const { setMemberCustomFields, resetBranchConfig } =
  branchConfigSlice.actions;
export default branchConfigSlice.reducer;
